module.exports = __webpack_public_path__ + "img/credit_card.4f5eb65.svg";